import React, { useEffect, useRef } from "react";
import LeaderLine from "react-leader-line";
import { useStateIfMounted } from "use-state-if-mounted";
import "./../../../css/app.css";
import mqtt_topics from "./../../../mqtt/mqtt_topics";
import Forecast from "./forecast";
import useCheckMobileScreen from "./useCheckMobileScreen";
import WeatherWidget from "./WeatherWidget";
const SurfDiagram = (props) => {
  const leaderLinesRef = useRef({});
  const mac = mqtt_topics.choosenmac; //"0-5b-96";
  const [state, setState] = useStateIfMounted({
    surftype: "", //"AMFES"
    gstatus: "", //"Feeding The Load"
    grunning: "", //true
    gonload: "", //true
    ustatus: "", // "Utility Absent"
    urunning: "", //false
    uonload: "", //false
    Load: "",
    GPower: "",
    UPower: "",
    Inverter: "",
    PV: "",
    BatCurrent: "",
    BatCapacity: "",
    designtype: localStorage.getItem("designtype_of_" + mac),
    gridPV: "",
    OGIPowerSet: "",
    HybWarningStatus: "",
    HybFault: "",
    BatWarning: "",
    fistupdate: 0,
    gAlarm: "",
    gWarning: "",
    MinSoC: "",
    BatCap: "",
  });

  const offlinetimeout = 60;
  let isMobile = useCheckMobileScreen();
  let vectorSize = isMobile ? 2 : 4;
  //let vectorEndPlugSize = useCheckMobileScreen() ? 0.75 : 1.5;
  let diagramFontSize = isMobile ? { fontSize: "12px" } : {};
  const isfuelsaver = localStorage
    .getItem("designtype_of_" + mac)
    .includes("FS");

  const diagramtopic =
    mqtt_topics.fixed_topic_part + mac + "/" + mqtt_topics.diagram_topic;

  function checkifemptystateofdata() {
    if (state.surftype == "" || state.surftype == undefined) {
      return true;
    }
    return false;
  }

  function requestdata() {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      mqtt_topics.diagram_topic,
    );
    mqtt_topics.busy_Requesting_Data = false;
    props.mqttClient.subscribe(diagramtopic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function requestmoredataforsas45k() {
    //mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + "0-5c-98" + mqtt_topics.request_topic,
      mqtt_topics.diagram_topic,
    );
    //mqtt_topics.busy_Requesting_Data = false;
    props.mqttClient.subscribe(
      mqtt_topics.fixed_topic_part + "0-5c-98/" + mqtt_topics.diagram_topic,
    );
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    /*let moretempdataforsas45k =
      mqtt_topics.choosenid == "SAS45K" &&
      topic ==
        mqtt_topics.fixed_topic_part + "0-5c-98/" + mqtt_topics.diagram_topic;*/
    if (topic == diagramtopic) {
      // || moretempdataforsas45k
      try {
        // message is Buffer
        message = JSON.parse(message.toString());
        /* if (moretempdataforsas45k) {
          setState((prevState) => ({
            ...prevState, // Spread the previous state to create a new object
            UPower: prevState.uonload
              ? (
                  prevState.Load -
                  Number(message.PV) -
                  prevState.gridPV +
                  Number(message.BatPower)
                ).toFixed(2)
              : 0,
            GPower: prevState.gonload
              ? (
                  prevState.Load -
                  Number(message.PV) -
                  prevState.gridPV +
                  Number(message.BatPower)
                ).toFixed(2)
              : 0,
            BatCurrent:
              message.BatCurrent === undefined
                ? message.BatPower === undefined
                  ? "0"
                  : Number(message.BatPower)
                : Number(message.BatCurrent),
            BatCapacity:
              message.BatCapacity === undefined
                ? "0"
                : Number(message.BatCapacity),
            PV: message.PV === undefined ? "0" : Number(message.PV).toFixed(2),
            fistupdate: state.fistupdate++,
          }));
        } else if (mqtt_topics.choosenid == "SAS45K") {
          setState((prevState) => ({
            ...prevState, // Spread the previous state to create a new object
            surftype: message.Type == undefined ? "" : message.Type,
            gstatus: message.gstatus == undefined ? "" : message.gstatus,
            grunning:
              message.grunning == undefined
                ? false
                : message.grunning == 0
                ? false
                : true,
            gonload:
              message.gonload == undefined
                ? false
                : message.gonload == 0
                ? false
                : true,
            ustatus: message.ustatus,
            urunning:
              message.urunning == undefined
                ? false
                : message.urunning == 0
                ? false
                : true,
            uonload:
              message.uonload == undefined
                ? false
                : message.uonload == 0
                ? false
                : true,
            Load:
              message.Load == undefined ? "" : Number(message.Load).toFixed(2),
            gridPV:
              message.PV == undefined ? "0" : Number(message.PV).toFixed(2),
            OGIPowerSet:
              message.OGIPowerSet == undefined
                ? "0"
                : Number(message.OGIPowerSet).toFixed(2),
            fistupdate: state.fistupdate++,
          }));
        } else {*/
        setState({
          ...state,
          surftype: message.Type == undefined ? "" : message.Type,
          gstatus: message.gstatus == undefined ? "" : message.gstatus,
          grunning:
            message.grunning == undefined
              ? false
              : message.grunning == 0
                ? false
                : true,
          gonload:
            message.gonload == undefined
              ? false
              : message.gonload == 0
                ? false
                : true,
          ustatus: message.ustatus,
          urunning:
            message.urunning == undefined
              ? false
              : message.urunning == 0
                ? false
                : true,
          uonload:
            message.uonload == undefined
              ? false
              : message.uonload == 0
                ? false
                : true,
          Load:
            message.Load == undefined ? "" : Number(message.Load).toFixed(2), //localStorage.getItem("designtype") == "FSHYBRBS" ? Number(message.Load1) + Number(message.Load2) + Number(message.Load3)
          Load1:
            message.Load1 == undefined ? "" : Number(message.Load1).toFixed(2),
          Load2:
            message.Load2 == undefined ? "" : Number(message.Load2).toFixed(2),
          Load3:
            message.Load3 == undefined ? "" : Number(message.Load3).toFixed(2),
          Load1S: message.Load1S == undefined ? "" : Number(message.Load1S),
          Load2S: message.Load2S == undefined ? "" : Number(message.Load2S),
          Load3S: message.Load3S == undefined ? "" : Number(message.Load3S),
          UPower:
            message.UPower == undefined
              ? "0"
              : Number(message.UPower).toFixed(2),
          GPower:
            message.GPower == undefined
              ? "0"
              : Number(message.GPower).toFixed(2),
          Inverter:
            message.Inverter == undefined
              ? "0"
              : Number(message.Inverter).toFixed(2),
          PV:
            message.PV == undefined
              ? message.HybPV == undefined
                ? "0"
                : Number(message.HybPV).toFixed(2)
              : Number(message.PV).toFixed(2),
          BatCurrent:
            message.BatCurrent == undefined
              ? message.BatPower == undefined
                ? "0"
                : Number(message.BatPower)
              : Number(message.BatCurrent),
          BatCapacity:
            message.BatCapacity == undefined
              ? "0"
              : Number(message.BatCapacity),
          gridPV:
            message.gridPV == undefined
              ? message.OGIPV == undefined
                ? "0"
                : Number(message.OGIPV).toFixed(2)
              : Number(message.gridPV).toFixed(2),
          OGIPowerSet:
            message.OGIPowerSet == undefined
              ? "0"
              : Number(message.OGIPowerSet).toFixed(2),
          HybWarningStatus:
            message.HybWarningStatus == undefined
              ? ""
              : message.HybWarningStatus,
          HybFault: message.HybFault == undefined ? "" : message.HybFault,
          BatWarning: message.BatWarning == undefined ? "" : message.BatWarning,
          gAlarm:
            message.gAlarm == undefined
              ? ""
              : Array.isArray(message.gAlarm)
                ? message.gAlarm.join(" ")
                : message.gAlarm,
          gWarning:
            message.gWarning == undefined
              ? ""
              : Array.isArray(message.gWarning)
                ? message.gWarning.join(" ")
                : message.gWarning,
          MinSoC: message.MinSoC == undefined ? "" : message.MinSoC,
          BatCap: message.BatCap == undefined ? "" : message.BatCap,
          fistupdate: state.fistupdate++,
        });
        localStorage.setItem(
          "BatCap_of_" + mac,
          message.BatCap == undefined ? "" : message.BatCap,
        );
        // }
      } catch (error) {
        console.log(message);
      }
    }
  }
  function formatStoredPercent(load, gPower, isMobile) {
    if (!gPower || isNaN(load) || isNaN(gPower)) return "";

    const value = 100 - (load * 100) / gPower;

    if (isNaN(value)) return "";

    return value.toFixed(0) + "%" + (isMobile ? "" : " Stored");
  }
  function updatearrowsaccordingtonewdata() {
    // Add new leader line from `start` to `end` (HTML/SVG element, basically)
    let designwithbatteries =
      state.designtype == "FSHYB" ||
      state.designtype == "FSCOMPHYB" ||
      state.designtype == "FSHYBRBS";
    createAndUpdateVectors(
      "towercell",
      "loadcell",
      state.uonload,
      "grid",
      "right",
      state.designtype == "FSOG" ? "top" : "right",
      "",
      "",
      "",
      "",
      state.designtype == "FSOG" ? 10 : "",
    );
    if (state.designtype == "FSOG") {
      //only for ongrid one
      createAndUpdateVectors(
        "inverter",
        "towercell",
        state.UPower < 0,
        "grid",
        "top",
        "right",
        "",
        "",
        state.UPower < 0 ? state.UPower * -1 + "kW Exported" : "",
      );
      /*
      state.UPower < 0
          ? ((+state.UPower + +state.Load) * -1).toFixed(2) + "kW Exported"
          : ""
      */
    } else {
      createAndUpdateVectors(
        "towercell",
        "inverter",
        state.uonload && designwithbatteries && state.UPower > 0,
        "grid",
        "right",
        "top",
        state.UPower > 0 ? state.UPower + "kW Imported" : "",
        "",
        "",
      );
      createAndUpdateVectors(
        "inverter",
        "towercell",
        state.uonload && designwithbatteries && state.UPower < 0,
        "grid",
        "top",
        "right",
        "",
        "",
        state.UPower < 0 ? state.UPower * -1 + "kW Exported" : "",
      );
      /*
      (mqtt_topics.choosenid == "SAS45K"
              ? state.UPower * -1
              : ((+state.UPower + +state.Load) * -1).toFixed(2)) 
      */
    }
    createAndUpdateVectors(
      "generatorcell",
      "inverter",
      state.gonload &&
        designwithbatteries &&
        Math.abs(state.BatCurrent).toFixed(2) - state.PV > 0,
      "grid",
      "left",
      "top",
      "",
      "",
      formatStoredPercent(state.Load, state.GPower, isMobile),
      "",
      "",
      [2, -30],
    );
    //when batteries are full or pv production is morethan charging current
    createAndUpdateVectors(
      "inverter",
      "generatorcell",
      state.gonload &&
        designwithbatteries &&
        (state.PV - parseFloat(Math.abs(state.BatCurrent).toFixed(2))).toFixed(
          2,
        ) > 0,
      "grid",
      "top",
      "left",
      (state.PV - parseFloat(Math.abs(state.BatCurrent).toFixed(2))).toFixed(
        2,
      ) +
        "kW " +
        (isMobile ? "FL" : "Feeding Load"),
      "",
      "",
      [2, -30],
    );
    createAndUpdateVectors(
      "generatorcell",
      "loadcell",
      state.gonload,
      "grid",
      "left",
      "top",
      state.GPower + "kW produced",
      "",
      designwithbatteries
        ? (state.BatCurrent == undefined
            ? state.BatPower == undefined
              ? state.BatCurrent == undefined
                ? "0"
                : state.BatCurrent
              : Number(state.BatPower)
            : Number(state.BatCurrent)) -
            state.PV <
          0
          ? "100%"
          : !isNaN(((state.Load * 100) / state.GPower).toFixed(0))
            ? ((state.Load * 100) / state.GPower).toFixed(0) +
              "%" +
              (isMobile ? "" : " Consumed")
            : ""
        : "",
      "",
      "",
      [2, -30],
    );
    /*createAndUpdateVectors(
      (state.BatCurrent == undefined
        ? state.BatPower == undefined
          ? state.BatCurrent == undefined
            ? "0"
            : state.BatCurrent
          : Number(state.BatPower)
        : Number(state.BatCurrent)) > 0
        ? "inverter"
        : "battery",
      (state.BatCurrent == undefined
        ? state.BatPower == undefined
          ? state.BatCurrent == undefined
            ? "0"
            : state.BatCurrent
          : Number(state.BatPower)
        : Number(state.BatCurrent)) > 0
        ? "battery"
        : "inverter",
      true,
      "straight",
      (state.BatCurrent == undefined
        ? state.BatPower == undefined
          ? "0"
          : Number(state.BatPower)
        : Number(state.BatCurrent)) > 0
        ? "bottom"
        : "top",
      (state.BatCurrent == undefined
        ? state.BatPower == undefined
          ? "0"
          : Number(state.BatPower)
        : Number(state.BatCurrent)) > 0
        ? "top"
        : "bottom"
    );*/
    const batValue =
      state.BatCurrent !== undefined
        ? Number(state.BatCurrent)
        : state.BatPower !== undefined
          ? Number(state.BatPower)
          : 0;

    const isCharging = batValue > 0;

    // First direction
    createAndUpdateVectors(
      "inverter",
      "battery",
      isCharging,
      "straight",
      "bottom",
      "top",
    );

    // Reverse direction
    createAndUpdateVectors(
      "battery",
      "inverter",
      !isCharging,
      "straight",
      "top",
      "bottom",
    );

    createAndUpdateVectors(
      "pv",
      "inverter",
      state.PV > 0 ? true : false,
      "straight",
      "left",
      "right",
    );
    createAndUpdateVectors(
      "inverter",
      "loadcell",
      (designwithbatteries && !state.gonload && !state.uonload) ||
        (!designwithbatteries && state.PV > 0),
      designwithbatteries ? "straight" : "grid",
      designwithbatteries ? "left" : "top",
      designwithbatteries ? "right" : "top",
      "",
      "",
      "",
      "",
      isMobile
        ? 21
        : state.uonload
          ? 77
          : state.surftype.toLowerCase().indexOf("amf") !== -1
            ? 77
            : 71,
    );
    /*
          designwithbatteries
        ? !(state.gonload == 0 ? false : true) &&
            !(state.uonload == 0 ? false : true)
    ||
            (state.BatCurrent == undefined
              ? state.BatPower == undefined
                ? state.BatCurrent == undefined
                  ? "0"
                  : state.BatCurrent
                : Number(state.BatPower)
              : Number(state.BatCurrent)) -
              state.PV <
              0: state.PV > 0 //|| state.gonload > 0 || state.uonload > 0
        ? true
        : false,
    
    */

    createAndUpdateVectors(
      "gridpv",
      "ongridinverter",
      state.gridPV > 0 && state.designtype == "FSCOMPHYB",
      "straight",
      "left",
      "right",
    );
    //from ongrid to load but this is a work around to be shown as to inverter
    createAndUpdateVectors(
      "ongridinverter",
      "inverter", // "loadcell",
      state.gridPV > 0 &&
        state.uonload == 0 &&
        state.gonload == 0 &&
        state.designtype == "FSCOMPHYB",
      "grid",
      "left",
      "left",
    );
    createAndUpdateVectors(
      "ongridinverter",
      "generatorcell",
      state.gridPV > 0 && state.gonload > 0 && state.designtype == "FSCOMPHYB",
      "grid",
      "top",
      "left",
    );
    createAndUpdateVectors(
      "ongridinverter",
      "towercell",
      state.gridPV > 0 &&
        state.uonload != 0 &&
        state.UPower != 0 &&
        state.designtype == "FSCOMPHYB",
      "grid",
      "top",
      "right",
    );
    if (state.designtype == "FSHYBRBS") {
      createAndUpdateVectors(
        "inverter",
        "loadcell1",
        state.Load1S > 0 && state.Load1 > 0,
        "grid",
        "left",
        "right",
      );
      createAndUpdateVectors(
        "inverter",
        "loadcell2",
        state.Load2S > 0 && state.Load2 > 0,
        "grid",
        "left",
        "right",
      );
      createAndUpdateVectors(
        "inverter",
        "loadcell3",
        state.Load3S > 0 && state.Load3 > 0,
        "grid",
        "left",
        "right",
      );
    }
    /*
          One of the following keywords to indicate how to draw the line:
          straight
          arc
          fluid
          magnet
          grid
          auto
    */
  }
  function calculateChargingOrDischargingTime() {
    let time;
    let label;

    // --- Detect equalizing ---
    const isEqualizing =
      state.BatCurrent > 0 && // AC charging connected
      state.BatCurrent < 1 && // Current below threshold
      state.BatCapacity >= 95; // High SoC

    if (isEqualizing) {
      return "Battery full (equalizing)";
    }

    if (state.BatCurrent > 0) {
      // --- Charging ---
      let taperFactor = 1;

      if (state.BatCapacity > 90) {
        // Smooth taper between 90–95%
        // At 90% → taperFactor = 1
        // At 95% → taperFactor = 0.3 (example)
        //const soc = state.BatCapacity;
        //taperFactor = 1 - ((soc - 90) / 5) * 0.7; // 90%→1, 95%→0.3
        const socRatio = (state.BatCapacity - 90) / 7; // 90–97% → 0–1
        taperFactor = Math.pow(1 - socRatio, 2); // quadratic
        if (taperFactor < 0.2) taperFactor = 0.2; // never drop below 0.2
      }

      time =
        ((state.BatCap * (1 - state.BatCapacity / 100)) / state.BatCurrent) *
        taperFactor;
      label = "Time to full charge: ";
    } else {
      // --- Discharging ---
      time =
        (state.BatCap * ((state.BatCapacity - state.MinSoC) / 100)) /
        Math.abs(state.BatCurrent);
      label = "Time to discharge: ";
    }

    // Convert time (in hours) to hh:mm
    const hours = Math.floor(Math.abs(time));
    const minutes = Math.floor((Math.abs(time) - hours) * 60);

    return (
      label +
      `${hours.toString().padStart(2, "0")}h ${minutes
        .toString()
        .padStart(2, "0")}m`
    );
  }

  useEffect(() => {
    //(mqtt_topics.choosenid == "SAS45K" ? 3 : 1)
    if (state.fistupdate > 1 && isfuelsaver) {
      updatearrowsaccordingtonewdata();
    }
  }, [state]);

  useEffect(() => {
    //update for more data
    /*if (mqtt_topics.choosenid == "SAS45K") {
      state.designtype = "FSCOMPHYB";
      if (!mqtt_topics.busy_Requesting_Data) {
        requestmoredataforsas45k();
      } else {
        setTimeout(function () {
          requestmoredataforsas45k();
        }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
      }
    }*/

    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata();
    } else {
      setTimeout(function () {
        requestdata();
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
    //clearsallvectors();
    const intervalforkeepcheckingifoffline = setInterval(() => {
      keepcheckingifoffline();
    }, 10000);
    return () => {
      clearInterval(intervalforkeepcheckingifoffline);
    };
  }, []);

  function keepcheckingifoffline() {
    let now = Math.floor(Date.now() / 1000);
    if (now - mqtt_topics.lasttimegotlivedata > offlinetimeout) {
      clearsallvectors();
    }
  }

  //when componenet unmount
  useEffect(
    () => () => {
      //console.log("diagram component unmount");
      props.mqttClient.unsubscribe(diagramtopic);
      props.mqttClient.removeListener("message", handleMqttMessage);
      /*if (mqtt_topics.choosenid == "SAS45K") {
        props.mqttClient.unsubscribe(
          mqtt_topics.fixed_topic_part + "0-5c-98/" + mqtt_topics.diagram_topic
        );
      }*/
      clearsallvectors();
    },
    [],
  );

  function clearsallvectors() {
    Object.keys(leaderLinesRef.current).map(function (target) {
      try {
        leaderLinesRef.current[target].remove();
        delete leaderLinesRef.current[target];
      } catch (Exception) {
        //console.log(Exception);
      }
    });
  }

  function displayled(where) {
    switch (where) {
      case "urunning": {
        if (state.urunning) {
          return require("./../../../images/diagram/normal/red_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/red_offIndicator.png");
      }
      case "uonload": {
        if (state.uonload) {
          return require("./../../../images/diagram/normal/green_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/green_offIndicator.png");
      }
      case "grunning": {
        if (state.grunning) {
          return require("./../../../images/diagram/normal/red_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/red_offIndicator.png");
      }
      case "gonload": {
        if (state.gonload) {
          return require("./../../../images/diagram/normal/green_onIndicator.png");
        }
        return require("./../../../images/diagram/normal/green_offIndicator.png");
      }
    }
  }

  function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset,
  ) {
    const fromEl = document.getElementById(from);
    const toEl = document.getElementById(to);

    if (!fromEl || !toEl) return;

    const target = `${from}_${to}`;
    const oppositTarget = `${to}_${from}`;
    //console.log("createAndUpdateVectors called:", from, to, onload);
    if (onload) {
      const options = {
        startPlugColor: "#1a6be0",
        endPlugColor: "#1efdaa",
        gradient: true,
        dash: { animation: true },
        path,
        startSocket,
        endSocket,
        size: vectorSize,
        startLabel: LeaderLine.captionLabel(startLabel, {
          color: "#1a6be0",
          offset: startoffset,
        }),
        middleLabel: LeaderLine.captionLabel(middleLabel, {
          color: "#1a6be0",
        }),
        endLabel: LeaderLine.captionLabel(endLabel, {
          color: "#1efdaa",
          offset: endoffset,
        }),
        startSocketGravity,
        endPlug:
          from === "ongridinverter" || to === "generatorcell"
            ? "behind"
            : "arrow1",
      };

      // update or create the main line
      if (leaderLinesRef.current[target]) {
        try {
          leaderLinesRef.current[target].setOptions(options);
        } catch (e) {
          leaderLinesRef.current[target] = new LeaderLine(
            fromEl,
            toEl,
            options,
          );
        }
      } else {
        leaderLinesRef.current[target] = new LeaderLine(fromEl, toEl, options);
      }

      // remove ONLY the opposite when onload = true
      /*if (leaderLinesRef.current[oppositTarget]) {
        try {
          leaderLinesRef.current[oppositTarget].remove();
        } catch (e) {}
        delete leaderLinesRef.current[oppositTarget];
      }*/
    } else {
      // ❗ remove ONLY the current line, not the opposite
      if (leaderLinesRef.current[target]) {
        try {
          leaderLinesRef.current[target].remove();
        } catch (e) {}
        delete leaderLinesRef.current[target];
      }

      /*if (leaderLinesRef.current[oppositTarget]) {
        try {
          leaderLinesRef.current[oppositTarget].remove();
        } catch (e) {}
        delete leaderLinesRef.current[oppositTarget];
      }*/
    }
  }

  /*function createAndUpdateVectors(
    from,
    to,
    onload,
    path,
    startSocket,
    endSocket,
    startLabel,
    middleLabel,
    endLabel,
    startoffset,
    startSocketGravity,
    endoffset
  ) {
    if (
      document.getElementById(from) != undefined &&
      document.getElementById(to) != undefined
    ) {
      let target = from + "_" + to;
      let oppositTarget = to + "_" + from;
      if (onload) {
        let options = {
          startPlugColor: "#1a6be0",
          endPlugColor: "#1efdaa",
          gradient: true,
          dash: { animation: true },
          path: path,
          startSocket: startSocket,
          endSocket: endSocket,
          //endPlugSize: vectorEndPlugSize,
          size: vectorSize,
          startLabel: LeaderLine.captionLabel(startLabel, {
            color: "#1a6be0",
            offset: startoffset,
          }),
          middleLabel: LeaderLine.captionLabel(middleLabel, {
            color: "#1a6be0",
          }),
          endLabel: LeaderLine.captionLabel(endLabel, {
            color: "#1efdaa",
            offset: endoffset,
          }),
          startSocketGravity: startSocketGravity,
          endPlug:
            from == "ongridinverter" || to == "generatorcell"
              ? "behind"
              : "arrow1",
        };
        if (leaderLinesRef.current[target] != undefined) {
          try {
            leaderLinesRef.current[target].setOptions(options);
          } catch (Exception) {
            //console.log(Exception);
            leaderLinesRef.current[target] = new LeaderLine(
              document.getElementById(from),
              document.getElementById(to),
              options
            );
            //check the opposit if found delete
            if (leaderLinesRef.current[oppositTarget] != undefined) {
              leaderLinesRef.current[oppositTarget].remove();
              delete leaderLinesRef.current[oppositTarget];
            }
          }
        } else {
          leaderLinesRef.current[target] = new LeaderLine(
            document.getElementById(from),
            document.getElementById(to),
            options
          );
          //check the opposit if found delete
          if (leaderLinesRef.current[oppositTarget] != undefined) {
            leaderLinesRef.current[oppositTarget].remove();
            delete leaderLinesRef.current[oppositTarget];
          }
        }
      } else {
        if (leaderLinesRef.current[target] != undefined) {
          try {
            leaderLinesRef.current[target].remove();
            delete leaderLinesRef.current[target];
          } catch (Exception) {
            //console.log(Exception);
          }
        }
      }
    }
  }*/

  function round20(x) {
    //return Math.ceil(x / 20) * 20; //round up
    //return Math.round(x / 20) * 20;//round down
    if (x >= 90) {
      return 100;
    } else if (x >= 70) {
      return 80;
    } else if (x >= 50) {
      return 60;
    } else if (x >= 30) {
      return 40;
    } else if (x >= 10) {
      return 20;
    } else if (x >= 0) {
      return 0;
    }
  }

  const capitalize = (v) => (v ? v.charAt(0).toUpperCase() + v.slice(1) : null);
  //console.log("props.passlevel:" + props.passlevel);
  const siteInfo = [
    mqtt_topics.choosenid && `📍 ${mqtt_topics.choosenid}`,
    props.passlevel && `🔐 ${capitalize(props.passlevel)} access`,
  ]
    .filter(Boolean)
    .join(" | ");

  if (checkifemptystateofdata()) {
    return (
      <div className="container">
        <div className="col">
          <div>
            <center>
              <img
                src={require("./../../../images/simpleloading.gif")}
                className="simpleloadingview"
              />
              <p>
                <strong>Loading Circuit Diagram ...</strong>
              </p>
            </center>
          </div>
        </div>
      </div>
    );
  } else {
    if (state.surftype.toLowerCase().indexOf("amf") !== -1) {
      switch (state.designtype) {
        case "FSHYBRBS":
          {
            //fuel save hybrid inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.ustatus}
                              </p>
                            </td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("urunning")}
                                  title="Utility Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("uonload")}
                                  title="Utility Onload Led"
                                />
                              </div>
                            </td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FStowercell"
                                  src={require("./../../../images/diagram/fuel_saver/tower.png")}
                                  title="Utility Tower"
                                  id="towercell"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.UPower > 0
                                        ? "bluetext"
                                        : "greentext"
                                    }
                                  >
                                    {state.UPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load1S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="First Load"
                                    id="loadcell1"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load1 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load2S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="Second Load"
                                    id="loadcell2"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load2 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load3S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="Third Load"
                                    id="loadcell3"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load3 + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent + "kW"}
                                    <br />
                                    {"(" + state.BatCapacity + "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSHYB":
          {
            //fuel save hybrid inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.ustatus}
                              </p>
                            </td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("urunning")}
                                  title="Utility Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("uonload")}
                                  title="Utility Onload Led"
                                />
                              </div>
                            </td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FStowercell"
                                  src={require("./../../../images/diagram/fuel_saver/tower.png")}
                                  title="Utility Tower"
                                  id="towercell"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.UPower > 0
                                        ? "bluetext"
                                        : "greentext"
                                    }
                                  >
                                    {state.UPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent + "kW"}
                                    <br />
                                    {"(" + state.BatCapacity + "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSOG":
          {
            //fuel save on grid inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.ustatus}
                              </p>
                            </td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("urunning")}
                                  title="Utility Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("uonload")}
                                  title="Utility Onload Led"
                                />
                              </div>
                            </td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FStowercell"
                                  src={require("./../../../images/diagram/fuel_saver/tower.png")}
                                  title="Utility Tower"
                                  id="towercell"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.UPower > 0
                                        ? "bluetext"
                                        : "greentext"
                                    }
                                  >
                                    {state.UPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/ongrid_inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>
                                    {state.OGIPowerSet != undefined
                                      ? "S" + state.OGIPowerSet + "kW"
                                      : ""}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSCOMPHYB":
          {
            // fuel save with ongrid and hybride inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.ustatus}
                              </p>
                            </td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("urunning")}
                                  title="Utility Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("uonload")}
                                  title="Utility Onload Led"
                                />
                              </div>
                            </td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FStowercell"
                                  src={require("./../../../images/diagram/fuel_saver/tower.png")}
                                  title="Utility Tower"
                                  id="towercell"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.UPower > 0
                                        ? "bluetext"
                                        : "greentext"
                                    }
                                  >
                                    {state.UPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="3"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/ongrid_inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Ongrid Inverter"
                                  id="ongridinverter"
                                />
                                <figcaption>
                                  <strong>
                                    {state.OGIPowerSet != undefined
                                      ? "S" + state.OGIPowerSet + "kW"
                                      : ""}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="gridpv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.gridPV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent + "kW"}
                                    <br />
                                    {"(" + state.BatCapacity + "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "ACGSTD": //standard AC Generator
        default: {
          return (
            <div className="row">
              <div className="col">
                <div className="card text-center bg-light livediagramcards">
                  <div className="card-body ">
                    <table
                      align="center"
                      style={{ tableLayout: "fixed", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td colSpan="2">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              {state.ustatus}
                            </p>
                          </td>
                          <td>
                            <hr className="vr" />
                          </td>
                          <td colSpan="2">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              {state.gstatus}
                              {state.gAlarm !== "" && (
                                <>
                                  <br />
                                  <span style={{ color: "#cc3300" }}>
                                    {state.gAlarm}
                                  </span>
                                </>
                              )}
                              {state.gWarning !== "" && (
                                <>
                                  <br />
                                  <span style={{ color: "#ffcc00" }}>
                                    {state.gWarning}
                                  </span>
                                </>
                              )}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan="">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("urunning")}
                                title="Utility Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("uonload")}
                                title="Utility Onload Led"
                              />
                            </div>
                          </td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td colSpan="">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("grunning")}
                                title="Genset Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("gonload")}
                                title="Genset Onload Led"
                              />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="tr_inmode_table">
                            <img
                              className="towercell"
                              src={
                                state.urunning
                                  ? require("./../../../images/diagram/normal/tower_on.png")
                                  : require("./../../../images/diagram/normal/tower.png")
                              }
                              title="Utility Tower"
                            />
                          </td>
                          <td>
                            <img
                              src={
                                state.uonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              className="loadcell"
                              src={require("./../../../images/diagram/normal/load.png")}
                              title="Load"
                            />
                          </td>
                          <td>
                            <img
                              src={
                                state.gonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              className="generatorcell"
                              src={
                                state.grunning
                                  ? require("./../../../images/diagram/normal/g1_on.png")
                                  : require("./../../../images/diagram/normal/g1.png")
                              }
                              title="Generator"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  <strong>{siteInfo}</strong>
                  <WeatherWidget />

                  <br />
                </div>
              </div>
            </div>
          );
        }
      }
    } else {
      switch (state.designtype) {
        case "FSHYBRBS":
          {
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan=""></td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load1S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="First Load"
                                    id="loadcell1"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load1 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load2S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="Second Load"
                                    id="loadcell2"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load2 + "kW"}
                                    </strong>
                                    <br />
                                  </figcaption>
                                  <img
                                    className="FS3loadcell"
                                    src={
                                      state.Load3S > 0
                                        ? require("./../../../images/diagram/fuel_saver/colored/onload.png")
                                        : require("./../../../images/diagram/fuel_saver/colored/offload.png")
                                    }
                                    title="Third Load"
                                    id="loadcell3"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load3 + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent +
                                      "kW (" +
                                      state.BatCapacity +
                                      "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSHYB":
          {
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan=""></td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent +
                                      "kW (" +
                                      state.BatCapacity +
                                      "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSOG":
          {
            //fuel save on grid inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan=""></td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/ongrid_inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>
                                    {state.OGIPowerSet != undefined
                                      ? "S" + state.OGIPowerSet + "kW"
                                      : ""}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "FSCOMPHYB":
          {
            // fuel save with ongrid and hybride inverter
            return (
              <div className="row" style={diagramFontSize}>
                <div className="col">
                  <div className="card text-center bg-light livediagramcards">
                    <div className="card-body ">
                      <table
                        align="center"
                        style={{ tableLayout: "fixed", width: "100%" }}
                      >
                        <tbody>
                          <tr>
                            <td colSpan="2"></td>
                            <td colSpan="1">
                              <hr className="vr" />
                            </td>
                            <td colSpan="2">
                              <p
                                className="card-text font-weight-bold"
                                align="center"
                              >
                                {state.gstatus}
                                {state.gAlarm !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#cc3300" }}>
                                      {state.gAlarm}
                                    </span>
                                  </>
                                )}
                                {state.gWarning !== "" && (
                                  <>
                                    <br />
                                    <span style={{ color: "#ffcc00" }}>
                                      {state.gWarning}
                                    </span>
                                  </>
                                )}
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colSpan=""></td>
                            <td colSpan="3"></td>
                            <td colSpan="">
                              <div>
                                <img
                                  className="ledimage"
                                  src={displayled("grunning")}
                                  title="Genset Running Led"
                                />
                                <label>
                                  &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                                </label>
                                <img
                                  className="ledimage"
                                  src={displayled("gonload")}
                                  title="Genset Onload Led"
                                />
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table"></td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSgeneratorcell"
                                  src={require("./../../../images/diagram/fuel_saver/generator.png")}
                                  title="Generator"
                                  id="generatorcell"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.GPower + "kW"}
                                  </strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="3"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/ongrid_inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Ongrid Inverter"
                                  id="ongridinverter"
                                />
                                <figcaption>
                                  <strong>
                                    {state.OGIPowerSet != undefined
                                      ? "S" + state.OGIPowerSet + "kW"
                                      : ""}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="gridpv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.gridPV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2">
                              <div>
                                <figure>
                                  <img
                                    className="FSloadcell"
                                    src={require("./../../../images/diagram/fuel_saver/home.png")}
                                    title="Load"
                                    style={{ height: "", width: "" }}
                                    id="loadcell"
                                  />
                                  <figcaption>
                                    <strong className="greentext">
                                      {state.Load + "kW"}
                                    </strong>
                                    <br />
                                    <strong>Consumption</strong>
                                  </figcaption>
                                </figure>
                              </div>
                            </td>
                            <td className="tr_inmode_table">
                              <figure>
                                <img
                                  className="FSinvertercell"
                                  src={require("./../../../images/diagram/fuel_saver/inverter.png")}
                                  style={{ height: "", width: "" }}
                                  title="Power Inverter"
                                  id="inverter"
                                />
                                <figcaption>
                                  <strong>&nbsp; &nbsp;</strong>
                                  <br />
                                  <strong>&nbsp; &nbsp;</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <figure>
                                <img
                                  className="FSpvcell"
                                  src={require("./../../../images/diagram/fuel_saver/pv.png")}
                                  style={{ height: "", width: "" }}
                                  title="Solar Panels"
                                  id="pv"
                                />
                                <figcaption>
                                  <strong className="bluetext">
                                    {state.PV + "kW"}
                                  </strong>
                                  <br />
                                  <strong>Solar Panels</strong>
                                </figcaption>
                              </figure>
                            </td>
                          </tr>
                          <tr>
                            <td className="tr_inmode_table" colSpan="2"></td>
                            <td className="tr_inmode_table" colSpan="">
                              <figure>
                                <img
                                  className="FSbatterycell"
                                  src={
                                    state.BatWarning == "Communication Lost"
                                      ? require("./../../../images/diagram/fuel_saver/battery-alert.png")
                                      : state.BatCurrent > 0
                                        ? require("./../../../images/diagram/fuel_saver/battery_charging.gif")
                                        : require(
                                            "./../../../images/diagram/fuel_saver/battery_" +
                                              round20(state.BatCapacity) +
                                              ".png",
                                          )
                                  }
                                  style={{ height: "", width: "" }}
                                  id="battery"
                                  title="Battery"
                                />
                                <figcaption>
                                  <strong
                                    className={
                                      state.BatCurrent > 0
                                        ? "greentext"
                                        : "bluetext"
                                    }
                                  >
                                    {state.BatCurrent + "kW"}
                                    <br />
                                    {"(" + state.BatCapacity + "% full)"}
                                  </strong>
                                  <br />
                                  <strong>Battery</strong>
                                </figcaption>
                              </figure>
                            </td>
                            <td className="tr_inmode_table" colSpan="2">
                              <strong>
                                {state.HybWarningStatus !== "" && (
                                  <>
                                    Inverter Status: {state.HybWarningStatus}
                                    <br />
                                  </>
                                )}
                              </strong>
                              <strong>
                                {state.HybFault != ""
                                  ? "Inverter Fault: " + state.HybFault
                                  : ""}
                              </strong>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <div></div>
                      {state.MinSoC != undefined &&
                        state.MinSoC != "" &&
                        state.BatCap != undefined &&
                        state.BatCap != "" &&
                        state.BatCapacity != 100 &&
                        state.BatCurrent != 0 && (
                          <strong
                            className={
                              state.BatCurrent > 0 ? "greentext" : "bluetext"
                            }
                          >
                            {calculateChargingOrDischargingTime()}
                          </strong>
                        )}
                    </div>
                    <strong>{siteInfo}</strong>
                    <WeatherWidget />

                    <br />
                  </div>
                </div>
              </div>
            );
          }
          break;
        case "ACGSTD": //standard AC Generator
        default: {
          return (
            <div className="row">
              <div className="col">
                <div className="card text-center bg-light livediagramcards">
                  <div className="card-body ">
                    <table
                      align="center"
                      style={{ tableLayout: "fixed", width: "100%" }}
                    >
                      <tbody>
                        <tr>
                          <td colSpan="3">
                            <p
                              className="card-text font-weight-bold"
                              align="center"
                            >
                              {state.gstatus}
                              {state.gAlarm !== "" && (
                                <>
                                  <br />
                                  <span style={{ color: "#cc3300" }}>
                                    {state.gAlarm}
                                  </span>
                                </>
                              )}
                              {state.gWarning !== "" && (
                                <>
                                  <br />
                                  <span style={{ color: "#ffcc00" }}>
                                    {state.gWarning}
                                  </span>
                                </>
                              )}
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td className="tr_inmode_table">
                            <img
                              className="loadcell"
                              src={require("./../../../images/diagram/normal/load.png")}
                              title="Load"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <img
                              src={
                                state.gonload
                                  ? require("./../../../images/diagram/normal/cont_close.png")
                                  : require("./../../../images/diagram/normal/cont_open.png")
                              }
                              className="contClose"
                              title="Contactor"
                            />
                          </td>
                          <td className="tr_inmode_table">
                            <div>
                              <img
                                className="ledimage"
                                src={displayled("grunning")}
                                title="Genset Running Led"
                              />
                              <label>
                                &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
                              </label>
                              <img
                                className="ledimage"
                                src={displayled("gonload")}
                                title="Genset Onload Led"
                              />
                            </div>
                            <img
                              className="generatorcell"
                              src={
                                state.grunning
                                  ? require("./../../../images/diagram/normal/g1_on.png")
                                  : require("./../../../images/diagram/normal/g1.png")
                              }
                              title="Generator"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  <strong>{siteInfo}</strong>
                  <WeatherWidget />

                  <br />
                </div>
              </div>
            </div>
          );
        }
      }
    }
  }
};
export default SurfDiagram;
